import React from 'react';
import { useParams } from 'react-router';
import { Container, Grid } from '@material-ui/core';
import UserGroupListPage from './components/UserGroupListPage';
import ClientEditSidebar, {
    ACTIVE_CLIENT_SIDEBAR_TAB_NAMES
} from '../clientedit/ClientEditSidebar';

function UserGroupsPage() {
    const { clientId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <ClientEditSidebar activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.usergroups} />
                <Grid className="pageContent">
                    <UserGroupListPage clientId={clientId} />
                </Grid>
            </Grid>
        </Container>
    );
}

export default UserGroupsPage;
